import React, { useContext } from "react";
import { Context } from "../../themeContext";
import { Redirect } from "react-router-dom";
import CryptoJS from "crypto-js";
import { decryptC } from "../../utils/util";
const idTag = localStorage.getItem("idTag");
const infoTag = localStorage.getItem("infoTag");

function SupportBoard() {
  const [state, _] = useContext(Context);
  const tag = CryptoJS.AES.decrypt(idTag, "m@123").toString(CryptoJS.enc.Utf8);

  const tagInfo = CryptoJS.AES.decrypt(infoTag, tag).toString(
    CryptoJS.enc.Utf8
  );
  const tagInfoSplit = tagInfo.split("/*/");
  const access_rmc = decryptC(tagInfoSplit[3]);
  const url_rmc = decryptC(tagInfoSplit[4]);
  const token_rmc = decryptC(tagInfoSplit[5]);

  const url = new URL(url_rmc);
  url.searchParams.append("emaild", state?.userInfo?.adresse_mail);
  url.searchParams.append("access_Token", token_rmc);

  return (
    <div className="content pb-4">
      {access_rmc === "true" && url_rmc && token_rmc ? (
        <iframe
          src={url}
          title="rmc"
          display="block"
          width="100%"
          // height= {`${deviceHeight}px -120px`}
          sendbox="allow-same-origin allow-popups"
          allowfullscreen="true"
          style={{ height: "100vh", border: "none" }}
          allowtransparency="true"
          // onLoad={() => setHide(true)}
        ></iframe>
      ) : (
        <Redirect to="/" />
      )}
    </div>
  );
}

export default SupportBoard;
